import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=f94b3b9c&scoped=true&"
var script = {}
import style0 from "./AppFooter.vue?vue&type=style&index=0&id=f94b3b9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94b3b9c",
  null
  
)

export default component.exports